import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventsService} from '../../../../services/events.service';

@Component({
  selector: 'app-questionnaire-input',
  templateUrl: './questionnaire-input.component.html',
  styleUrls: ['./questionnaire-input.component.scss'],
})
export class QuestionnaireInputComponent implements OnInit {
    @Input() form: string = 'review-report';
    @Input() title: string;
    @Input() hint: string;
    @Input() answer: string;
    @Output() answerChange = new EventEmitter<string>();
    @Input() placeholder: string;
    @Input() hasLine = false;
    @Input() disabled = false;

    constructor(private event: EventsService) {
    }

    ngOnInit() {
    }

    onAnswerChange(value: string) {
        this.event.publish('form:changed', this.form);
        this.answerChange.emit(value);
    }
}
